import { httpRequest } from "../../api/client"

type HttpMethod = "GET" | "POST" | "PUT" | "PATCH" | "DELETE"

/**
 * Solicitud HTTP autenticada. A diferencia de la version anterior, propaga
 * el error como ApiError para que el caller decida que hacer (mostrar toast,
 * reintentar, redirigir, etc) en lugar de tragarlo silenciosamente.
 *
 * @returns Cuerpo JSON parseado como T, o null si la respuesta es 204.
 * @throws ApiError si la solicitud falla.
 */
export const handleRequest = async <T = unknown>(
  method: HttpMethod,
  endpoint: string,
  body?: object | null,
  token?: string,
): Promise<T | null> => {
  const result = await httpRequest<T>(method, endpoint, body ?? undefined, {
    token,
  })
  return (result ?? null) as T | null
}

/**
 * Variante que arma `endpoint/{id}` y exige token. Mantiene la firma legacy
 * para los componentes que aun la usan.
 */
export const handleRequestSingle = async <T = unknown>(
  method: HttpMethod,
  endpoint: string,
  token: string,
  id?: string,
  body?: object,
): Promise<T | null> => {
  const url = id ? `${endpoint}/${id}` : endpoint
  return handleRequest<T>(method, url, body ?? null, token)
}
